import { render, staticRenderFns } from "./CommonQuestion.vue?vue&type=template&id=a209d87e"
import script from "./CommonQuestion.vue?vue&type=script&lang=js"
export * from "./CommonQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports